import { Component, OnInit, Input, HostBinding, Output, EventEmitter } from '@angular/core';

import { Task } from 'src/app/shared/models';
import { TaskService } from '../../services/task.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { TaskType } from 'src/app/shared';
import { ZoningCodeService } from '../../services';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { processDetailViewComponentFactory } from '../../factories/process-detail-view-component.factory';
import { appSettings } from 'src/settings/config';

@Component({
    standalone: false,
    selector: 'app-task-view',
    templateUrl: './task-view.component.html',
    styleUrls: ['./task-view.component.scss']
})
export class TaskViewComponent implements OnInit {
    @Input()
    task: ITaskModel;

    @Input()
    showStatus = true;

    @Input()
    showCheckStatus: boolean;

    @Input()
    showReindexButton: boolean;

    @Input()
    showRecalculateButton: boolean;

    @Input()
    showTaskTabButton: boolean;

    @Input()
    showStartStopButton: boolean = true;

    @Input()
    showClearThreadsButton: boolean = true;

    @Input()
    showProcessDetailsPopupButton: boolean = false;

    @Input()
    zcName: string;

    @Output()
    deleteProcess: EventEmitter<boolean> = new EventEmitter();

    @Input()
    dark: boolean = true;

    @HostBinding('class')
    hostClass = 'task-view';

    showTaskTab: boolean = appSettings.showTaskTab;

    constructor(
        private readonly taskService: TaskService,
        private readonly dialog: MatDialog,
        private readonly zoningCodeService: ZoningCodeService
    ) {}

    ngOnInit() {}

    checkStatus(event: Event) {
        this.taskService.getTaskById(this.task).subscribe(task => {
            this.openTaskInfoDialog(task);
        });
        event.stopPropagation();
    }

    startTask(event: Event) {
        this.taskService.startTask(this.task).subscribe();
        event.stopPropagation();
    }

    stopTask(event: Event) {
        this.taskService.stopTask(this.task).subscribe();
        event.stopPropagation();
    }

    updateTask(partialModel) {
        if (!partialModel) {
            return;
        }
        this.taskService.updateTask(this.task, partialModel).subscribe();
    }

    get zoningCode() {
        return this.zoningCodeService.getZoningCodeById(this.task.zoningCodeId);
    }

    get zoningCodeVersion() {
        return { Id: this.task.zcVersionId, Tasks: [this.task], instanceId: this.task.instanceId };
    }

    get isTask(): boolean {
        return this.task instanceof Task;
    }

    get showSlider() {
        return this.task.type === TaskType.ZC_VERSION_CALCULATION && this.task.canStop;
    }

    get isZoningCodeVersion() {
        return this.task.isCalculation;
    }

    get isZoningCode() {
        return Task.isIndexing(this.task);
    }

    get canShowCheckStatus() {
        return this.isTask && this.showCheckStatus;
    }

    openTaskInfoDialog(task: ITaskModel) {
        if (!task) {
            return;
        }
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = task;
        dialogConfig.maxHeight = '900px';
        dialogConfig.maxWidth = '900px';

        this.dialog.open(processDetailViewComponentFactory(task.type), dialogConfig);
    }
}
